import { BUTTON_SIZES } from 'ui/button';
import { CounterBadge } from 'ui/badge';
import { Tab, TabGroup } from 'ui/tabs';
import { LIST_TYPES } from 'constants/listTypes';
import {
  BtnAndSearchWrapper,
  HeaderWrapper,
  SelectedListsCountBtn,
  WideInputSearch,
} from '../../AudienceSelection.styled';
import { useAudienceContext } from '../../context';

export const AUDIENCE_HEADER_TEST_ID = 'audience-header';
export const SEARCH_PLACEHOLDER = 'Search by name or ID';
export const SEARCH_TEST_ID = 'list-input-search';
export const SELECTED_LIST_COUNT_BTN_TEST_ID = 'selected-list-count-btn';
export const NO_SELECTED_LISTS = 'No lists selected';
export const ALL_LIST_TYPES = 'All';
const { DYNAMIC, INTERNAL, STANDARD, SUPPRESSION } = LIST_TYPES;
export const LIST_TYPE_TABS = [ALL_LIST_TYPES, STANDARD, DYNAMIC, SUPPRESSION, INTERNAL];

export const AudienceSelectionHeader = () => {
  const { listTypes, searchText, selectedListsCount, handleListTypeChange, handleSearch } =
    useAudienceContext();

  const selectedTab = listTypes.length === 1 ? listTypes[0] : ALL_LIST_TYPES;

  return (
    <HeaderWrapper data-test={AUDIENCE_HEADER_TEST_ID}>
      <TabGroup selectedTab={selectedTab} onTabChange={handleListTypeChange}>
        {LIST_TYPE_TABS.map((tab) => (
          <Tab id={tab} key={tab} label={tab} />
        ))}
      </TabGroup>
      <BtnAndSearchWrapper>
        <SelectedListsCountBtn
          size={BUTTON_SIZES.LARGE}
          data-test={SELECTED_LIST_COUNT_BTN_TEST_ID}
        >
          {selectedListsCount > 0 ? (
            <>
              <span>Selected</span>
              <CounterBadge>{selectedListsCount}</CounterBadge>
            </>
          ) : (
            NO_SELECTED_LISTS
          )}
        </SelectedListsCountBtn>
        <WideInputSearch
          id={SEARCH_TEST_ID}
          data-test={SEARCH_TEST_ID}
          onChange={handleSearch}
          placeholder={SEARCH_PLACEHOLDER}
          value={searchText}
        />
      </BtnAndSearchWrapper>
    </HeaderWrapper>
  );
};
